export default "__VITE_ASSET__DtFE0Sxo__"